@if (breadcrumb.length > 0) {
  <nav class="mb-2">
    <ol class="flex flex-wrap items-center gap-1.5">
      @for (bread of breadcrumb; track $index; let last = $last; let first = $first){
        @if (!last){

          @if(first){
            <li>
              <a [routerLink]="[bread.url]" [innerHTML]="bread.title" class="flex uppercase text-vge items-center gap-1.5 text-sm hover:text-vge dark:text-gray-400 dark:hover:text-brand-400"></a>
            </li>
            <li class="flex uppercase items-center gap-1.5 text-sm text-gray-800 dark:text-white/90">
              <span class="select-none"> / </span>
            </li>
          } @else {
            <li class="flex uppercase items-center gap-1.5 text-sm text-gray-800 dark:text-white/90">
              <a [routerLink]="[bread.url]" [innerHTML]="bread.title"></a>
            </li>
            <li class="flex uppercase items-center gap-1.5 text-sm text-gray-800 dark:text-white/90">
              <span class="select-none"> / </span>
            </li>
          }
        } @else {
          <li class="flex uppercase items-center gap-1.5 text-sm text-gray-800 dark:text-white/90" [innerHTML]="bread.title"></li>
        }
      }
    </ol>
  </nav>
}
